import { render, staticRenderFns } from "./AgencyProjectViewTemplate.vue?vue&type=template&id=66b9ab73&scoped=true&"
import script from "./AgencyProjectViewTemplate.vue?vue&type=script&lang=js&"
export * from "./AgencyProjectViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b9ab73",
  null
  
)

export default component.exports